import { Container, Row, Col, Image } from 'react-bootstrap'

const WhatToShow = () => (
    <>
    <div className="section-what-to-show">
        <Container className="text-center">
            <h2><span>Here is What</span><br/>
            <strong>I'm going to show you</strong></h2>
            <hr/>
            <Row>
                <Col md={3} xs={6}>
                    <p><Image src="../images/discover/img-why-we-get-sick01.png" alt="Why We Age and Get Sick" className="img-fluid d-block mx-auto"/></p>
                    <p>Why We Age <br/>
                        and Get Sick</p>
                </Col>
                <Col md={3} xs={6}>
                    <p className="d-md-block d-none">&nbsp;</p>
                    <p><Image src="../images/discover/img-vitamins-minerals01.png" alt="What Vitamins & Minerals Do" className="img-fluid d-block mx-auto"/></p>
                    <p>What Vitamins &amp; <br/>
                        Minerals Do</p>
                </Col>
                <Col md={3} xs={6}>
                    <p className="d-md-block d-none">&nbsp;</p>
                    <p><Image src="../images/discover/img-supplements-are-important01.png" alt="Why Supplements Are Important" className="img-fluid d-block mx-auto"/></p>
                    <p>Why Supplements <br/>
                        Are Important</p>
                </Col>
                <Col md={3} xs={6}>
                    <p><Image src="../images/discover/img-vitamin-checklist01.png" alt="The Vitamin Checklist" className="img-fluid d-block mx-auto"/></p>
                    <p>The Vitamin <br/>
                        Checklist</p>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-what-to-show {
                font-size: 18px;
                line-height: 30px;
                color: #1b1b1b;
            }

            .section-what-to-show .container {
                padding-top: 70px;
                padding-bottom: 70px;
            }

            .section-what-to-show h2 {
                font-size: 28px;
                line-height: 36px;
            }

            .section-what-to-show h2 span {
                font-size: 18px;
                text-transform: uppercase;
            }

            .section-what-to-show hr {
                width: 84px;
                border-bottom: 3px solid rgba(67,166,73,1.00);
            }

            @media (min-width: 768px) and (max-width: 991.98px) {

                .section-what-to-show {
                    font-size: 16px;
                    line-height: 24px;
                }

            }

            @media (max-width: 767.98px) {

                .section-what-to-show {
                    font-size: 16px;
                    line-height: 20px;
                }

                .section-what-to-show .container {
                    padding-top: 40px;
                    padding-bottom: 40px;
                }

                .section-what-to-show h2 {
                    font-size: 20px;
                    line-height: 26px;
                }

                .section-what-to-show h2 span {
                    font-size: 16px;
                }

                .section-what-to-show hr {
                    margin-bottom: 40px;
                }

            }

            @media (max-width: 575.98px) {

                .section-what-to-show p {
                    font-size: 14px;
                }

            }

        `}</style>
    </>
);

export default WhatToShow;